module.exports = __webpack_public_path__ + "static/media/arrow-right-icon.a575bda3.png";